import { changePasswordActionTypes } from '../constants/ApiConstants';

const initialState = {
  loading: false,
  changePasswordData: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case changePasswordActionTypes.post_changePassword.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case changePasswordActionTypes.post_changePassword.SUCCESS:
    return {
      ...state,
      loading: false,
      changePasswordData: payload,
    };
  case changePasswordActionTypes.post_changeSuperadminPassword.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case changePasswordActionTypes.post_changeSuperadminPassword.SUCCESS:
    return {
      ...state,
      loading: false,
      changePasswordData: payload,
    };
  default:
    return state;
  };
};



// WEBPACK FOOTER //
// ./src/components/changePassword/reducers/changePasswordReducer.js